export default __webpack_public_path__ + "8df5a265fa8caa979a9c12764c1303e4.svg";